import { InputRightAddon as ChakraInputRightAddon } from '@chakra-ui/react';

export const InputRightAddon = ChakraInputRightAddon;
